<template>
  <div>
    <aside class="search_result">
      <div class="search_result__header">
        <p class="search_result__text"><span class="result_num" v-text="resultCount || 0" />台</p>
      </div>
      <attention-text-parts class="search_result__note" :type="type" />
      <div
        v-if="type === 'used' || type === 'unused'"
        class="search_result__sort"
        :class="{'is-current': sortOpen}"
      >
        <span class="search_result__sort-label">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.2901 13.8743L11.7041 15.2884L6.99709 20L2.29004 15.2884L3.70412 13.8743L5.99705 16.1673V4.99998H7.99707V16.1673L10.2901 13.8743ZM16.9971 4L12.29 8.71197L13.7041 10.126L15.9971 7.83302V19H17.9971V7.83311L20.29 10.126L21.704 8.71197L16.9971 4Z" fill="#4e4e4e" /></svg> 並び替え</span>
        <button
          @click="toggleSort"
          class="search_result__sort-button"
          type="button"
        >
          <span v-text="selectSortLabel" />
        </button>
        <div class="search_result__sort-list">
          <dl
            class="search_result__sort-item"
            v-for="(item, i) in sortList"
            :key="`sortList${i}`"
          >
            <dt
              class="search_result__sort-item__label"
              v-text="item.title"
            />
            <dd
              class="search_result__sort-item__value"
              :class="{'search_result__sort-item__value--selected': sortValue == sort.value && sortDirection == sort.direction }"
              v-for="(sort, j) in item.value"
              :key="`sortListValue${i}${j}`"
              v-text="sort.label"
              @click="changeSort(sort.value, sort.direction)"
            />
          </dl>
        </div>
      </div>
    </aside>

    <section class="search_result__list" :class="`search_result__list--${type}`">
      <search-result-item-parts
        class="search_result__list-item"
        v-for="(item, i) in resultBikeList"
        :key="`searchResultItem${i}`"
        :id="`id-${item.product_id}`"
        :item="item"
        :type="type"
        :banner="banner"
      />
    </section>
    <div class="search_result__more" v-if="pagination.current_page !== pagination.page_count">
      <p><a class="button button--black" @click="moreLoad">もっと見る</a></p>
    </div>
  </div>
</template>

<script>
import {defineComponent, computed, ref, watch} from 'vue'
import {Util} from '../master.js'
import SearchFormSection from './SearchFormPane/SearchFormSection.vue'
import SearchResultItemParts from './SearchResultPane/parts/SearchResultItemParts.vue'
import AttentionTextParts from './SearchResultPane/parts/AttentionTextParts.vue'

export default defineComponent({
  name: 'SearchResultPane',
  components: {
    SearchFormSection,
    SearchResultItemParts,
    AttentionTextParts
  },
  props: {
    type: {
      type: String,
      default: 'new',
    },
    searchResult: {
      type: Object,
      default: () => {},
    },
    banner: {
      type: Array,
      default: () => []
    },
    sortValue: {
      type: String,
      default: 'created'
    },
    sortDirection: {
      type: String,
      default: 'desc'
    }
  },
  setup(props) {
    const
      resultBikeList = computed(() => props.searchResult?.data),
      resultCount = computed(() => props.searchResult?.pagination.count),
      pagination = computed(() => props.searchResult?.pagination),
      sortList = Util.SEARCH_SORT,
      sortValue = computed(() => props.sortValue),
      sortDirection = computed(() => props.sortDirection)

    const
      selectSortLabel = ref('Web掲載の新しい順'),
      sortOpen = ref(false)

    const setButtonLabel = () => {
      sortList.forEach((sort) => {
        sort.value.forEach((value) => {
          if (value.value === sortValue.value && value.direction === sortDirection.value) {
            value.selected = true
            selectSortLabel.value = value.label
          }
        })
      })
    }

    // sortValue.value と sortDirection.value を監視して setButtonLabel を実行する
    watch([sortValue, sortDirection], () => {
      setButtonLabel()
    })

    return {
      resultBikeList,
      resultCount,
      pagination,
      sortValue,
      sortDirection,
      sortList,
      selectSortLabel,
      sortOpen,
      setButtonLabel
    }
  },
  mounted() {
    this.setButtonLabel()
  },
  methods: {
    moreLoad() {
      this.$emit('moreLoad')
    },
    changeSort(sortValue, sortDirection) {
      this.$emit('sortChange', sortValue, sortDirection)
      this.toggleSort()
    },
    toggleSort() {
      this.sortOpen = !this.sortOpen
    },
  }
})

</script>